import styled from 'styled-components';

export const IconWrapper = styled.div`
  font-size: 16px;
  margin: 0px 5px;
  &:hover {
    color: #0046ff;
  }
`;
